import { useState } from "react";
import { useLocation } from "react-router-dom";
import style from "./../../styles/Sidebar.module.css";
import MenuItem from "./MenuItem";

const Menu = ({ setIsSandwichOpen, isSandwichOpen, navData }) => {
  const location = useLocation();
  const [active, setActive] = useState(location.pathname);
  return (
    <>
      {navData.map((item, index) => {
        return (
          <MenuItem
            subnavigation={item.subnavigation}
            setIsSandwichOpen={setIsSandwichOpen}
            item={item}
            key={index}
            isSandwichOpen={isSandwichOpen}
            active={active}
            setActive={setActive}
          />
        );
      })}
    </>
  );
};

export default Menu;
